export const input = {
	baseStyle: {
		field: {
			bg: 'field.background',
		},
	},
	sizes: {
		md: {
			field: {
				color: 'white',
				fontSize: '14px',
				_placeholder: {
					color: 'field.placeholder',
				},
			},
		},
	},
	variants: {
		base: {},
	},
	defaultProps: {
		variant: 'base',
	},
};
